export default __webpack_public_path__ + "static/column-with-negative-values-02b47e64543b2a22bb964e431c86b61a.png";